import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { Grid, Input } from 'semantic-ui-react';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';
class Add extends React.Component {

  state = {
    open: false,
    load: false
  };


  addDetails() {
    let context = this;
    let name = document.getElementById('name').value;
    if (name == '' || name == undefined || name == null) {
      alert('Enter the UPI!!!');
      return;
    }
    let data = { 'upi': name };
    context.setState({
      load: true,
      message: 'Adding UPI Details'
    })
    $.ajax({
      type: 'POST',
      data: data,
      url: Server() + 'upidetails/add.php',
      success: function(data)
      {
        context.setState({
          load: false
        });
        if (data == 1) {
          context.props.updateDatas(data);
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  render() {
    const { fullScreen } = this.props;
    const { load, message } = this.state;
    let loading;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    return (
      <div>
        <Dialog fullScreen={fullScreen} open={this.props.open}
         onClose={this.handleClose} aria-labelledby="responsive-dialog-title">
          <DialogTitle id="responsive-dialog-title" style={{width: 500}}>{"Add UPI Details"}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Grid fluid>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  <Input id='name' focus placeholder='UPI'
                      style={{ borderColor: '#5A9CBB' }} fluid />
                </Grid.Column>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.closeAdd} color="black">
              Close
            </Button>
            <Button onClick={this.addDetails.bind(this)}
                color="primary" autoFocus>
              Add
            </Button>
          </DialogActions>
        </Dialog>
        {loading}
      </div>
    );
  }
}

Add.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
};

export default withMobileDialog()(Add);
